import { AppState } from '@/store';
import { Breakpoints } from '@settings';
import { useSelector } from 'react-redux';
import { useMediaQuery } from 'react-responsive';
import CategoryList from './CategoryList';
import ColorList from './ColorList';
import Designs from './Designs';
import SizeList from './SizeList';
import TypeList from './TypeList';

type Props = {
  rel?: string;
};

const Sidebar = ({ rel }: Props) => {
  const isTabletOrLarger = useMediaQuery({ minWidth: Breakpoints.MD });
  const { category } = useSelector((state: AppState) => state.partner.filterOptions);

  return (
    <>
      {isTabletOrLarger && <Designs {...{ rel }} />}
      <CategoryList {...{ rel }} />
      {category && category === 9 && <TypeList {...{ rel }} />}
      {category && <SizeList {...{ rel }} />}
      {category && <ColorList {...{ rel }} />}
      {/*<GraphicTypeList {...{rel}} />*/}
    </>
  );
};

export default Sidebar;
